import React from 'react';
import { withPrefix } from "gatsby";
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';
import Section from '../Layout/Section/Section';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';
import RenderStackedHeadline from  '../Utils/RenderStackedHeadline';
import RenderSocialIcon from '../Utils/RenderSocialIcon';

import './image-blocks.scss';

function renderBody(block, i) {
  const body = [];

  if (block.body && block.body[0]) {
    block.body.forEach(line => {
      body.push(<p key={i} className="body-copy">{line.line}</p>);
    });
  }

  if(block.bullets && block.bullets[0]) {
    body.push(renderBullets(block, "bullets-"));
  }

  return body;
}
function renderBody2(block, i) {
  const body = [];

  if (block.body2 && block.body2[0]) {
    body.push(<p key={i} className="body-copy">{block.body2[0].line}</p>);
  }

  if(block.bullets && block.bullets[0]) {
    body.push(renderBullets(block, "bullets-"));
  }

  return body;
}

function renderBullets(block, key) {
  const listItems = [];
    
  if (block.bullets && block.bullets[0].bullet !== "") {
    block.bullets.map((item, i) => {
      return listItems.push(
        <li key={key+i} className="animate-on-scroll">{item.bullet}</li>
      )
    })
    
    return <ul key={"bullets"}>{listItems}</ul>;
  }
}

function renderVideo(video, type) {
  const videoURL = video.src.includes("http") ? video.src : withPrefix('/' + video.src);
  return <video controls width="100%"><source src={videoURL} type="video/mp4" /></video>
}

function renderBlocks(blocks, socialIcons) {
  const allBlocksHTML = [];
  if (blocks) {
    blocks.forEach((block, i) => {
      // console.log(block);
      const blockHTML = [];
      if (block.headline || block.body || block.leader || block.image || block.icon || block.headlines || block.video) {
        blockHTML.push(
          <div key={i} className={`block with-${block.type}`}>
            {block.socialIcons ? RenderSocialIcon(block.socialIcons) : ''}
            {block.image ? renderImage(block.image, block.type) : ''}
            {block.video ? renderVideo(block.video, block.type) : ''}
            {block.icon ? renderImage(block.icon, block.type) : ''}
            {block.leader ? <p className="leader">{block.leader}</p> : ''}
            {block.headline ? <h3 className={`headline ${block.headline.length < 6 ? "xlarge" : ''}`}>{block.headline}</h3> : ''}
            {block.headlines ? renderHeadlines(block.headlines) : ''}
            {block.body ? renderBody(block, i) : ''}
            {block.bullets ? renderBullets(block, "bullets-") : ''}
            {block.headline2 ? <h3 className={`headline2 ${block.headline2.length < 5 ? "xlarge" : ''}`}>{block.headline2}</h3> : ''}
            {block.body2 ? renderBody2(block, i) : ''}
            {block.headline3 ? <h3 className={`headline2 ${block.headline3.length < 5 ? "xlarge" : ''}`}>{block.headline3}</h3> : ''}
            {block.trailer ? <p className="leader">{block.trailer}</p> : ''}
          </div>
        )
      }
      allBlocksHTML.push(blockHTML);
    })
  }

  function renderHeadlines(headlines) {
    let headlinesHTML = [];
    
    if(headlines && headlines[0]) {
      headlines.forEach ((headline, i) => {
        // console.log("headline: ", headline);
        headlinesHTML.push(<span className="headline multi-line">{headline.line}</span>)
      })
    }

    return headlinesHTML;
  }

  return allBlocksHTML;
}

function renderImage(image, type) {
  const blockType = type ? type : "image";

  return (
    <PreviewCompatibleImage
      customClass={blockType}
      imageInfo={image}
      alt={blockType}
    />
  )
}

const ImageBlocks = ({ copy, variant, id }) => {
  const modClass = copy ? `show-${copy.blocks.length}` : '';

  return (
    <Section id={id} customClass={["image-blocks",  `${variant ? variant : ''}`]}>
      {copy ? RenderStackedHeadline(copy) : ''}
      <InnerContainer customClass={["image-blocks__container", modClass]}>
        {renderBlocks(copy.blocks)}
      </InnerContainer>
    </Section>
  )
}

export default ImageBlocks
